import React from "react";

function Intro() {
  return (
    <section className="page-banner">
      <div className="container">
        <div className="page-content-wrapper">
          <h1 className="page-title">Newsletters</h1>
          <p className="page-description">
            Latest ESG updates, insights, and more
          </p>
        </div>
      </div>
    </section>
  );
}

export default Intro;
